import { DsDialogCloseDirective } from 'src/app/shared/components/ds-dialog/ds-dialog.component';
import { DsButtonComponent } from 'src/app/shared/components/ds-button/ds-button.component';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NotRespondingService } from './not-responding.service';

import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
  imports: [DsDialogCloseDirective, DsButtonComponent, TranslateModule, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-not-responding',
  templateUrl: './not-responding.component.html',
})
export class NotRespondingComponent {
  retrying$ = this._notRespondingService.retrying$;

  constructor(private _notRespondingService: NotRespondingService) {}

  retry(): void {
    this._notRespondingService.setRetry(true);
  }
}
